import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingLegalClientDocument,
  useLegalClientCompleteLegalHeadOnboardingMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useLegalClientCompleteLegalHeadOnboarding = () => {
  const [handle, { loading, error: apolloError }] =
    useLegalClientCompleteLegalHeadOnboardingMutation({
      refetchQueries: [OnboardingLegalClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  const complete = useCallback(
    async (legalId: string, legalHeadId: string) => {
      const res = await handle({
        variables: { id: legalId, legalHeadId },
      });
      return !!res.data?.legalClientCompleteLegalHeadOnboarding;
    },
    [handle]
  );

  return {
    loading,
    error,
    complete,
  };
};
